import { FloatingHint } from "@rapid/components/FloatingHint";
import { useModel } from "@rapid/contexts/ModelContext";

export const DownloadingHint = ({ isVideo }: { isVideo: boolean }) => {
    const { isDownloading, downloadProgress } = useModel();
    const progressPercentage = Math.round(downloadProgress);
    const fileType = isVideo ? "video" : "image";

    return (
        <FloatingHint
            isVisible={isDownloading}
            isDismissable={false}
            message={
                <>
                    <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                    <span>
                        Downloading {fileType}... {progressPercentage}%
                    </span>
                </>
            }
        />
    );
};
